module.exports = __webpack_public_path__ + "static/media/arrow-left.044c5457.svg";